import React, { createContext, useContext, useEffect, useState, useRef } from "react";

const OrdersLayoutContext = createContext({ isCompactCards: false });

export const OrdersLayoutProvider = ({ children, threshold = 768 }) => {
  const containerRef = useRef(null);
  const [isCompactCards, setIsCompactCards] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const checkWidth = (width) => {
      setIsCompactCards(width < threshold);
    };

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const width = entry.contentRect?.width || el.offsetWidth;
          checkWidth(width);
        }
      });
      observer.observe(el);
      return () => observer.disconnect();
    }

    const handleResize = () => {
      if (el) checkWidth(el.offsetWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [threshold]);

  return (
    <OrdersLayoutContext.Provider value={{ isCompactCards }}>
      <div ref={containerRef} className="futuresOrders__container-scope" style={{ width: "100%", minWidth: 0 }}>
        {children}
      </div>
    </OrdersLayoutContext.Provider>
  );
};

export const useOrdersLayout = () => useContext(OrdersLayoutContext);
